<mat-dialog-actions>
  <button type="button" mat-button mat-raised-button color="primary" [disabled]="this.isFormRL_DownloadDisabled" (click)="openDialog()">
    Download RL Form
  </button>
</mat-dialog-actions>
<div>
  @if (profile) {
    <app-rl-dialog [profile]="profile" class="rl-option"></app-rl-dialog>
  }
</div>